/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tickets: NonNullable<unknown> }} Any_Mad_Rook_TreatInputs */

const fr_any_mad_rook_treat = /** @type {(inputs: Any_Mad_Rook_TreatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il te reste encore ${i?.tickets} séances, tu peux t'inscrire tranquillement`)
};

/**

* @param {Any_Mad_Rook_TreatInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const any_mad_rook_treat = /** @type {((inputs: Any_Mad_Rook_TreatInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Any_Mad_Rook_TreatInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_any_mad_rook_treat(inputs)
});